import React, { useEffect, useState } from "react";
import authStore from "@/stores/authStore";
import { observer } from "mobx-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import popupService from "@/services/popupService";
import api from "@/services/api";
import "./login.css";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import LaluneLogo from "@/assets/images/lalun-logo-login.svg";
import LoginPageIcon from "@/assets/images/LoginPageIcon.png";
import { CredentialState } from "@/models/enums";

const cacheLtr = createCache({
    key: "muiltr",
});

const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
});

const EasyLoginPage = () => {
    const [credentialState, setCredentialState] = useState(CredentialState.Pending);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    function setDir(isRtl: boolean) {
        const body = document.querySelector("body");
        const cls = isRtl ? "rtl" : "ltr";
        body?.classList.add(cls);
        body?.setAttribute("dir", cls);
    }

    const checkCredentials = async () => {
        try {
            const res = await api.authInfo();
            setDir(res.data.initResponse.isRtl);
            if (res.data.initResponse.cultureName !== localStorage.getItem("Culture")) {
                localStorage.setItem("Culture", res.data.initResponse.cultureName);
                window.location.reload();
                return;
            }
            authStore.update(res.data);
            setCredentialState(CredentialState.Success);
        } catch {
            setCredentialState(CredentialState.Error);
        }
    };

    const easyLogin = async () => {
        const payload = searchParams.toString();
        if (payload) {
            popupService.showLoading();
            try {
                await api.easyLogin(payload);
                checkCredentials();
                navigate("/");
            } catch (err) {
                await popupService.showApiError(err);
                navigate("/login");
                return;
            }
        }
    };

    useEffect(() => {
        easyLogin();
    }, []);

    const renderView = () => {
        return (
            <CacheProvider value={authStore.isRtl ? cacheRtl : cacheLtr}>
                <div className="login-main-page">
                    <div className="login-left-side">
                        <div className="login-header">
                            <div className="login-header-wello">
                                <img src={LaluneLogo} alt="LaluneLogo" style={{ maxWidth: 121, width: "100%" }} />
                            </div>
                            <div className="login-header-logo">Logo</div>
                        </div>
                    </div>
                    <div className="login-right-side">
                        <img src={LoginPageIcon} alt="LoginPageIcon" />
                    </div>
                </div>
            </CacheProvider>
        );
    };

    const render = () => {
        return renderView();
    };

    return render();
};

export default observer(EasyLoginPage);
